import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {
  FiGrid, FiActivity, FiUsers, FiDollarSign, FiShield, FiTruck,
  FiCheckSquare, FiBarChart2, FiHome, FiTarget,
} = FiIcons;

export const SLIVERS = [
  { id: 'holistic', label: 'Holistic', icon: FiGrid, hint: 'Group-wide summary' },
  { id: 'ops', label: 'Operations', icon: FiActivity, hint: 'SLA, jobs, fitment flow' },
  { id: 'hr', label: 'Human Resources', icon: FiUsers, hint: 'People, training, safety' },
  { id: 'finance', label: 'Finance', icon: FiDollarSign, hint: 'Revenue, GP, cash, ROI' },
  { id: 'iso', label: 'ISO Compliance', icon: FiCheckSquare, hint: 'QMS, NCR, CAPA, audits' },
  { id: 'compliance', label: 'Risk & Compliance', icon: FiShield, hint: 'Safety, legal, POPIA' },
  { id: 'supply', label: 'Supply Chain', icon: FiTruck, hint: 'Stock, suppliers, DIFOT' },
  { id: 'sales', label: 'Commercial', icon: FiBarChart2, hint: 'Quotes, insurers, NPS' },
  { id: 'measurability', label: 'Measurability', icon: FiTarget, hint: 'Staff KPIs, badges, wall of fame' },
];

const SliverNav = () => (
  <aside className="w-20 bg-black border-r border-white/10 flex flex-col items-center py-6 gap-2 shrink-0 z-20">
    <div className="w-12 h-12 flex items-center justify-center border border-white/15 mb-4">
      <span className="font-doto font-black text-white text-xl leading-none">
        PG<span className="text-[#D71921]">.</span>
      </span>
    </div>
    {SLIVERS.map((s) => (
      <NavLink
        key={s.id}
        to={`/sliver/${s.id}`}
        className={({ isActive }) =>
          `group relative w-12 h-12 flex items-center justify-center border transition-all ${
            isActive
              ? 'border-[#D71921] bg-[#D71921]/10 text-[#D71921]'
              : 'border-white/5 text-neutral-500 hover:border-white/30 hover:text-white clickable-glow'
          }`
        }
      >
        <SafeIcon icon={s.icon} className="text-lg" />
        <div className="absolute left-full ml-3 px-3 py-2 bg-[#0A0A0A] border border-white/10 opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap z-50 transition-opacity">
          <div className="font-mono-tech text-[10px] uppercase tracking-widest text-white">{s.label}</div>
          <div className="font-mono-tech text-[9px] text-neutral-500 mt-0.5">{s.hint}</div>
        </div>
      </NavLink>
    ))}
  </aside>
);

export default SliverNav;
